import React, { forwardRef, useState } from 'react'
import { MenuItem, Select } from '@material-ui/core'
import { useSelectStyles } from './inputs.styles'
import clsx from 'clsx'

const SelectPlaceholder = forwardRef((props, ref) => {
  const { value, InputProps, ...other } = props
  const [showPlaceholder, setShowPlaceholder] = useState(!props?.value)
  const NONE = 'none'
  const classes = useSelectStyles()
  const onFocus = e => {
    setShowPlaceholder(false)
    other?.onFocus && other.onFocus(e)
  }
  const onClose = e => {
    setShowPlaceholder(!props?.value)
    other?.onClose && other.onClose(e)
  }

  const onChange = e => {
    const { name, value, ...other } = e.target
    other?.onChange &&
      other.onChange({
        target: { name, value: value === NONE ? '' : value, ...other }
      })
  }

  return (
    <Select
      ref={ref}
      value={!!value ? value : NONE}
      defaultValue={NONE}
      onFocus={onFocus}
      onClose={onClose}
      onChange={onChange}
      className={clsx(
        !value && other?.placeholder ? classes.selectPlaceHolder : null,
        props?.className
      )}
      {...other}
    >
      {other?.placeholder && (
        <MenuItem
          className={!showPlaceholder ? classes.menuItemHidden : null}
          key="0"
          disabled
          value="none"
        >
          {other?.placeholder}
        </MenuItem>
      )}
      {props.children}
    </Select>
  )
})
export default SelectPlaceholder
